import React, { useEffect, useState } from 'react';
import useGlobalStore from '../../hooks/useGlobalStore';
import { CallWithAuth } from '../../actions/apiAction';
import { CREATE_CHECKOUT_SESSION, GET_SUBSCRIPTION_PLANS } from '../../utils/apiUrl';
import toast from 'react-hot-toast';

const UpgradeSubscriptionModal = ({
    creatorId,
    creatorDetails,
    userDetails: userDetailsProp,
    subscriptionLimit,
    openFrom,
    lockOpen = false,
}) => {
    const userDetails = creatorDetails || userDetailsProp;
    const { TOGGLE_UPGRADE_SUBSCRIPTION, offForModal } = useGlobalStore();
    const [plans, setPlans] = useState([])
    const [dragStart, setDragStart] = useState(0);
    const [dragOffset, setDragOffset] = useState(0);
    const handleClose = () => {
        if (lockOpen) return;
        offForModal('TOGGLE_UPGRADE_SUBSCRIPTION');
    };
    const handleNotClose = () => console.log("Not Close Modal")

    const handleDragStart = (e) => {
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;
        setDragStart(clientY);
    };

    const handleDragMove = (e) => {
        if (dragStart === 0) return;
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;
        const offset = clientY - dragStart;
        if (offset > 0) setDragOffset(offset);
    };

    const handleDragEnd = () => {
        if (!lockOpen && dragOffset > 100) {
            handleClose();
        }
        setDragStart(0);
        setDragOffset(0);
    };

    const getSubscriptionList = async () => {
        const responce = await CallWithAuth("GET", GET_SUBSCRIPTION_PLANS(creatorId));
        if (responce?.data) setPlans(responce.data);
    };
    useEffect(() => {
        getSubscriptionList();
    }, [])

    const createCheckoutSession = async (planId) => {
        const responce = await CallWithAuth("POST", CREATE_CHECKOUT_SESSION,
            { plan_id: planId, creator_id: creatorId }
        );
        console.log('responce', responce)
        if (responce.status === 200) {
            if (responce?.data?.checkout_url) {
                window.location.href = responce?.data?.checkout_url
            } else {
                toast.error("Something went wrong!")
            }
        } else {
            toast.error(responce?.data?.detail)
        }

    }
    const formatMinutesToClock = (value) => {
        const minutes = Number(value);
        if (Number.isNaN(minutes)) return '00:00';

        const totalSeconds = Math.max(0, Math.round(minutes * 60));
        const wholeMinutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        return `${String(wholeMinutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };
    const formatMessageCount = (value) => {
        const count = Number(value);
        if (Number.isNaN(count)) return '0';
        return String(Math.max(0, Math.floor(count)));
    };
    return (
        <>
            {/* start: upgrade-overlay */}

            {TOGGLE_UPGRADE_SUBSCRIPTION && (
                <div
                    className="fixed inset-0 bg-black/50 backdrop-blur-[2px] z-40"
                    onClick={lockOpen ? undefined : handleClose}
                />
            )}
            <div
                className={`fixed bottom-0 left-0 right-0 bg-card rounded-t-3xl shadow-2xl z-50 h-[85%] overflow-y-auto
                 transition-all ${dragStart === 0 ? 'duration-300' : 'duration-0'} ${TOGGLE_UPGRADE_SUBSCRIPTION && dragStart === 0 ? '!translate-y-[0]' : 'translate-y-full'}`}
                style={{ transform: dragStart !== 0 && !lockOpen ? `translateY(${dragOffset}px)` : undefined }}
            >
                <div
                    className={`flex justify-center pt-3 pb-2 sticky top-0 z-10 bg-white ${lockOpen ? '' : 'cursor-grab active:cursor-grabbing'}`}
                    onMouseDown={lockOpen ? undefined : handleDragStart}
                    onMouseMove={lockOpen ? undefined : handleDragMove}
                    onMouseUp={lockOpen ? undefined : handleDragEnd}
                    onMouseLeave={lockOpen ? undefined : handleDragEnd}
                    onTouchStart={lockOpen ? undefined : handleDragStart}
                    onTouchMove={lockOpen ? undefined : handleDragMove}
                    onTouchEnd={lockOpen ? undefined : handleDragEnd}
                >
                    {!lockOpen && <div className="w-12 h-1 bg-border rounded-full" />}
                </div>
                <div className="p-6 pb-8">
                    <div className="text-center mb-6">
                        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-lock w-8 h-8 text-primary"
                            >
                                <rect width={18} height={11} x={3} y={11} rx={2} ry={2} />
                                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-bold text-foreground mb-2">
                            {openFrom === 'paywall' || lockOpen
                                ? `Subscribe to chat with ${userDetails?.first_name ?? "them"}`
                                : openFrom === 'voice'
                                    ? `Voice call limit reached`
                                    : openFrom === 'video'
                                        ? `Video call limit reached`
                                        : `Keep talking to ${userDetails?.first_name ?? ""}`
                            }
                        </h2>
                        <p className="text-foreground/70 text-sm">
                            {openFrom === 'paywall' || lockOpen
                                ? `Choose a plan to unlock messages, voice, and video with ${userDetails?.first_name ?? "this creator"}.`
                                : openFrom === 'voice'
                                    ? `You've used up your voice minutes. Upgrade to continue talking to ${userDetails?.first_name ?? ""}`
                                    : openFrom === 'video'
                                        ? `You've used up your video minutes. Upgrade to continue talking to ${userDetails?.first_name ?? ""}`
                                        : `Upgrade and keep hitting it off with your favorite creator!`
                            }
                        </p>



                    </div>
                    <div className="gap-y-6 mb-6 flex flex-col">
                        {
                            plans.length > 0 &&
                            plans.map((it, ind) => {
                                return (
                                    <div
                                        className={it?.name == "Premium" ? "bg-gradient-to-br from-primary/20 via-card to-accent/20 rounded-2xl p-3 p-lg-5 border-2 border-primary relative" : "bg-gradient-to-br from-primary/20 via-card to-accent/20  rounded-2xl p-3 p-lg-5 border border-border relative"}
                                        style={{ opacity: 1, transform: "none" }}
                                        key={it?.id}
                                    >
                                        {
                                            it?.best_value == true &&

                                            <div className="absolute -top-4 left-2 md:left-1/2 transform md:-translate-x-1/2 bg-primary text-primary-foreground px-3 md:min-w-[194px] py-1.5 rounded-full text-sm font-bold flex items-center justify-center gap-1.5 shadow-lg">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width={24}
                                                    height={24}
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="#fff"
                                                    strokeWidth={2}
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="lucide lucide-star w-4 h-4"
                                                >
                                                    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                                                </svg>
                                                Best Value
                                            </div>
                                        }
                                        {
                                            it?.discount_percentage &&
                                            <div className="absolute -top-4 right-2 right-md-4 bg-success text-white px-4 py-1.5 rounded-full text-sm font-bold shadow-lg">
                                                {it?.discount_percentage}% OFF
                                            </div>
                                        }
                                        <div className="flex justify-between items-start mb-3 mt-2">
                                            <div>
                                                <h3 className="text-xl font-bold text-foreground">{it?.name}</h3>
                                                <p className="text-xs text-muted-foreground">
                                                    {it?.description}
                                                </p>
                                            </div>
                                            <div className="text-right">
                                                {it?.slashed_price && <p className="text-sm text-muted-foreground line-through">${Number(it?.slashed_price).toFixed(2)}</p>}
                                                <p className="text-3xl font-bold text-primary">${it?.price}</p>
                                                <p className="text-xs text-muted-foreground">{it?.interval}</p>
                                            </div>
                                        </div>
                                        <div className="space-y-1 text-sm text-foreground/80 mb-4">
                                            {
                                                it?.marketing_features?.length > 0 &&
                                                it?.marketing_features?.map((item, index) => {
                                                    return <p className="flex items-center gap-2" key={index}>
                                                        {
                                                            index == 0 ?
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width={24}
                                                                    height={24}
                                                                    viewBox="0 0 24 24"
                                                                    fill="none"
                                                                    stroke="#d7428c"
                                                                    strokeWidth={2}
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    className="lucide lucide-sparkles w-4 h-4 text-primary"
                                                                >
                                                                    <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
                                                                    <path d="M20 3v4" />
                                                                    <path d="M22 5h-4" />
                                                                    <path d="M4 17v2" />
                                                                    <path d="M5 18H3" />
                                                                </svg> : <span>•</span>
                                                        }
                                                        {item}</p>
                                                })

                                            }

                                        </div>
                                        {
                                            !it?.is_current_plan ?
                                                <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-primary/90 h-10 bg-primary text-primary-foreground hover:opacity-90 rounded-full px-8 py-6 text-lg font-semibold shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105 w-full"
                                                    disabled={it?.is_current_plan}
                                                    onClick={() => createCheckoutSession(it?.id)}
                                                >
                                                    {it?.name == "Premium" ? 'Get Premium' : `Continue with ${it?.name}`}
                                                </button> : null}
                                    </div>
                                )
                            })
                        }
                    </div>
                    <p className="text-xs text-center text-muted-foreground px-4">
                        By continuing, you'll unlock continued access to Reya. You can cancel
                        anytime from your account settings.
                    </p>
                </div>
            </div>
        </>

    );
}

export default UpgradeSubscriptionModal;